import React from "react";
import ModeSelector from "./ModeSelector";

function App() {
  return <ModeSelector />;
}

export default App;
